import React from "react"

import Button from "src/components/Button"
import Form from "src/components/Form"

import { useCopyToClipboard } from "src/hooks/use_copy_to_clipboard"

import { getCurrentMarinaSlug } from "src/utils/url/parsing/marina"

const BoaterFormLink = () => {
  const marinaSlug = getCurrentMarinaSlug()
  const copyToClipboard = useCopyToClipboard()

  const pathToBoaterForm = new URL(
    `/explore/destination/${marinaSlug}/waitlists/long_term/entries/new`,
    window.location.origin
  ).toString()

  const copyLinkToBoaterForm = () =>
    copyToClipboard(pathToBoaterForm, "Link copied to clipboard")

  return (
    <div>
      <div className="mb-2">Link to boater form</div>
      <div className="relative">
        <Form.IconTextField
          readOnly
          value={pathToBoaterForm}
          position="right"
          icon={
            <Button onClick={copyLinkToBoaterForm} variant="tertiary" small>
              Copy link
            </Button>
          }
        />
      </div>
    </div>
  )
}

export default BoaterFormLink
